import React from "react";
import { Link } from "react-router-dom";
import Reveal, { Eyebrow } from "../common/Reveal";
import { difference } from "../../mock";

export default function Difference() {
  return (
    <section id="difference" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center">
          <Reveal><Eyebrow>{difference.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink">{difference.title}</h2></Reveal>
          <Reveal delay={140}><p className="mt-5 max-w-2xl mx-auto text-lybl-muted text-lg">{difference.subtitle}</p></Reveal>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {difference.items.map((it, i) => (
            <Reveal key={it.n} delay={i * 70}>
              <div className="h-full rounded-2xl border border-lybl-ink/10 p-6 hover:border-lybl-green/30 hover:bg-lybl-cream/40 transition-colors">
                <span className="font-serif text-3xl text-lybl-rust">{it.n}</span>
                <h3 className="mt-3 font-serif text-lg text-lybl-ink">{it.title}</h3>
                <p className="mt-2 text-[14px] text-lybl-muted leading-relaxed">{it.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {difference.resultCards.map((c, i) => (
            <Reveal key={c.title} delay={i * 90}>
              <div className="group overflow-hidden rounded-3xl ring-1 ring-black/5">
                <div className="h-48 overflow-hidden">
                  <img src={c.image} alt={c.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6 bg-lybl-cream/60">
                  <h3 className="font-serif text-2xl text-lybl-ink">{c.title}</h3>
                  <div className="mt-4 grid grid-cols-2 gap-4">
                    {c.stats.map((s) => (
                      <div key={s.text}>
                        <p className="font-serif text-2xl text-lybl-green">{s.value}</p>
                        <p className="mt-1 text-[13px] text-lybl-muted leading-snug">{s.text}</p>
                      </div>
                    ))}
                  </div>
                  <p className="mt-4 text-[13px] text-lybl-ink/70">{c.tags}</p>
                  <p className="mt-1 text-[12px] text-lybl-muted">{c.meta}</p>
                  <Link to={c.to} className="mt-4 inline-flex items-center gap-1 text-[14px] font-medium text-lybl-rust">Learn more <span aria-hidden>→</span></Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-4 text-[12px] text-lybl-muted text-center">*Results may vary depending on individual.</p>
      </div>
    </section>
  );
}
